import { Box, Link, Typography } from "@mui/material";
import React from "react";
import { useConnectivityInfo } from "../ConnectivityMonitor";

const RETRY_NOW_THRESHOLD_S = 3;

export const ConnectivityOverlay: React.FC = () => {
  const { countdown, retryNow } = useConnectivityInfo();

  return (
    <>
      {/* Blocks pointer events; zIndex above the modal layer so it shows over full-screen Dialogs (editor). */}
      <Box
        data-testid="blocking-overlay"
        sx={(theme) => ({
          position: "fixed",
          inset: 0,
          zIndex: theme.zIndex.modal + 1,
          pointerEvents: "all",
          backgroundColor: "rgba(0,0,0,0.15)",
          backdropFilter: "blur(4px)",
        })}
      />
      {/* Connectivity banner */}
      <Box
        role="alert"
        aria-live="assertive"
        sx={(theme) => ({
          position: "fixed",
          top: "16px",
          left: "16px",
          right: "16px",
          zIndex: theme.zIndex.modal + 2,
          borderRadius: "8px",
          backgroundColor: "error.main",
          color: "error.contrastText",
          py: 1,
          px: 3,
          display: "flex",
          alignItems: "center",
          gap: 1,
        })}
      >
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          Connection lost; retrying in {countdown}s
          {countdown > RETRY_NOW_THRESHOLD_S && (
            <span>
              {" ("}
              <Link
                component="button"
                variant="body2"
                onClick={retryNow}
                sx={{
                  fontWeight: 600,
                  color: "inherit",
                  textDecorationColor: "inherit",
                  cursor: "pointer",
                }}
              >
                Retry now
              </Link>
              )
            </span>
          )}
        </Typography>
      </Box>
    </>
  );
};
